import { paths } from "src/routes/paths";
import { ICONS, liveStreamIcon, settingIcon } from "./menuIcons";
import { t } from "i18next";

export function getFacilityNav(): { subheader: string; items: any }[] {
  // t: (key: string) => string
  return [
    // OVERVIEW
    // ----------------------------------------------------------------------
    {
      subheader: "",
      items: [
        {
          title: t("mainpage"),
          path: paths.dashboard.root,
          icon: ICONS.dashboard,
        },
      ],
    },
    {
      subheader: t("dashboard"),
      items: [
        // Events
        {
          title: t("profile_data"),
          path: paths.dashboard.profile.data,
          icon: ICONS.file,
          children: [
            {
              title: t("profile"),
              path: paths.dashboard.profile.data,
            },
            { title: t("images"), path: paths.dashboard.profile.images },
            { title: t("sports"), path: paths.dashboard.profile.sports },
            { title: t("venues"), path: paths.dashboard.profile.venues },

            {
              title: t("billing_infos"),
              path: paths.dashboard.profile.billing_infos,
            },
            // { title: t("staff"), path: paths.dashboard.profile.staff },
          ],
        },
        {
          title: t("settings"),
          path: paths.dashboard.settings.global,
          icon: settingIcon,
          children: [
            {
              title: t("global_settings"),
              path: paths.dashboard.settings.global,
            },
            {
              title: t("admin_menu_services"),
              path: paths.dashboard.settings.pricing,
            },

            // ...(venueMenu ? [venueMenu] : []),
            // {
            //   title: t("training"),
            //   path: paths.dashboard.settings.training.root,
            // },
            // { title: t("course"), path: paths.dashboard.event.course },
            {
              title: t("blocking"),
              path: paths.dashboard.settings.blocking.root,
            },
            {
              title: t("playermenu_passestickets"),
              path: paths.dashboard.settings.passestickets.passes,
              children: [
                {
                  title: t("passes"),
                  path: paths.dashboard.settings.passestickets.passes,
                },

                {
                  title: t("tickets"),
                  path: paths.dashboard.settings.passestickets.tickets,
                },
              ],
            },
          ],
        },
        {
          title: t("calendar"),
          path: paths.dashboard.calendar,
          icon: ICONS.calendar,
        },
        {
          title: t("transactions"),
          path: paths.dashboard.applications,
          icon: ICONS.invoice,
        },

        {
          title: t("athletes"),
          path: paths.dashboard.user.list,
          icon: ICONS.user,
        },

        // {
        //   title: t("messages"),
        //   path: paths.dashboard.chat,
        //   icon: ICONS.chat,
        // },

        {
          title: t("analytics"),
          path: paths.dashboard.analytics,
          icon: ICONS.analytics,
        },
        {
          title: t("payment_management"),
          path: paths.dashboard.payment_management,
          icon: ICONS.payment_management,
        },
        {
          title: t("newsfeed"),
          path: paths.dashboard.post.root,
          icon: ICONS.blog,
          children: [
            { title: t("news"), path: paths.dashboard.post.root },
            // { title: t("details"), path: paths.dashboard.post.demo.details },
            { title: t("add_new"), path: paths.dashboard.post.new },
            // { title: t("edit"), path: paths.dashboard.post.demo.edit },
          ],
        },
        {
          title: t("livestreaming"),
          path: paths.dashboard.livestreaming,
          icon: liveStreamIcon,
        },
        {
          title: t("adminuser_management"),
          path: paths.dashboard.adminuser_management,
          icon: ICONS.adminuser_management,
        },
      ],
    },
  ];
}
